import { ObfuscatedGameState } from "@presidents/game-engine";

export function diffHand(
  handA: ObfuscatedGameState["myHand"],
  handB: ObfuscatedGameState["myHand"]
): NonNullable<ObfuscatedGameState["myHand"]>["cards"] | undefined {
  const handBSet = new Set(handB?.cards.map((c) => c._id));
  return handA?.cards.filter((c) => !handBSet.has(c._id));
}
